'use client';

import { useEffect } from 'react';

/**
 * Applies the user's saved Accessibility settings (high contrast, reduced
 * motion, keyboard nav hints, font size) to <html> on first load of any page.
 *
 * Before this existed, those classes/styles were only ever toggled from
 * inside the Accessibility settings page itself (goonpals/settings/
 * accessibility/page.tsx) as a side effect of flipping a switch there — so a
 * saved preference had zero effect anywhere else in the app, and even
 * reloading the settings page itself lost the visual state until you
 * re-toggled. This provider is the missing "apply what's saved" step; the
 * settings page still does its own immediate classList.toggle on each
 * change so switches feel live while you're on that page.
 */
export function AccessibilityPreferencesProvider() {
  useEffect(() => {
    fetch('/api/preferences')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const prefs = data?.preferences;
        if (!prefs) return;
        const html = document.documentElement;
        html.classList.toggle('high-contrast', !!prefs.high_contrast_mode);
        html.classList.toggle('reduce-motion', !!prefs.reduce_motion);
        html.classList.toggle('keyboard-navigation-enabled', prefs.keyboard_navigation_hints !== false);
        if (prefs.font_size_px) {
          html.style.fontSize = `${prefs.font_size_px}px`;
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
